/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MiddlewareError,
  StoreProfilePreviewQuery,
  StoreProfilePreviewResponse,
} from '../models/index';
import {
    MiddlewareErrorFromJSON,
    MiddlewareErrorToJSON,
    StoreProfilePreviewQueryFromJSON,
    StoreProfilePreviewQueryToJSON,
    StoreProfilePreviewResponseFromJSON,
    StoreProfilePreviewResponseToJSON,
} from '../models/index';

export interface CreateStoreProfilePreviewOfCurrentRetailerRequest {
    storeProfilePreviewQuery: StoreProfilePreviewQuery;
}

/**
 * 
 */
export class StoreProfilePreviewResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for createStoreProfilePreviewOfCurrentRetailer without sending the request
     */
    async createStoreProfilePreviewOfCurrentRetailerRequestOpts(requestParameters: CreateStoreProfilePreviewOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['storeProfilePreviewQuery'] == null) {
            throw new runtime.RequiredError(
                'storeProfilePreviewQuery',
                'Required parameter "storeProfilePreviewQuery" was null or undefined when calling createStoreProfilePreviewOfCurrentRetailer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/store-profile/preview`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StoreProfilePreviewQueryToJSON(requestParameters['storeProfilePreviewQuery']),
        };
    }

    /**
     */
    async createStoreProfilePreviewOfCurrentRetailerRaw(requestParameters: CreateStoreProfilePreviewOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreProfilePreviewResponse>> {
        const requestOptions = await this.createStoreProfilePreviewOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreProfilePreviewResponseFromJSON(jsonValue));
    }

    /**
     */
    async createStoreProfilePreviewOfCurrentRetailer(requestParameters: CreateStoreProfilePreviewOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreProfilePreviewResponse> {
        const response = await this.createStoreProfilePreviewOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
